export default __webpack_public_path__ + "static/media/field_any_packed.a086f713.png";